import { Link, useLocation } from 'react-router-dom'
import { Formik, Form, Field } from 'formik'
import * as Yup from 'yup'
import { apiInstance } from 'configuration/axios'
import { useEffect, useState, useMemo } from 'react'
import ResultBox from './Components/resultBox'
import { searchKeywordResult } from 'interface'
import { thaimonth } from 'utils'
import Swal from 'sweetalert2'
import moment from 'moment'
interface MyFormValues {
  keyword: string
}
function useQuery() {
  const { search } = useLocation()

  return useMemo(() => new URLSearchParams(search), [search])
}
const FormSchema = Yup.object().shape({
  keyword: Yup.string().min(2, 'Too Short!').max(50, 'Too Long!').required('Required'),
})
const CheckProductSerial = () => {
  const query = useQuery()
  const serial = query.get('serial')
  const initialValues: MyFormValues = { keyword: serial ?? '' }
  const [result, setResult] = useState<searchKeywordResult[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [datetimeSearch, setDatetimeSearch] = useState<string>('')
  const [resultNotFound, setResultNotFound] = useState<boolean>(false)
  const [notFoundKeyword, setNotFoundKeyword] = useState<string | null>(null)

  const searchKeyword = (values: MyFormValues) => {
    setResultNotFound(false)
    setIsLoading(true)
    setResult([])

    apiInstance
      .get(`/productSerial/search?keyword=${values.keyword}`)
      .then(res => {
        if (res.data.length === 0) {
          // Swal.fire({
          //     title: 'Error!',
          //     text: 'ไม่พบข้อมูลที่ค้นหา',
          //     icon: 'error',
          //     confirmButtonText: 'ปิด'
          //   })
          setResultNotFound(true)
          setNotFoundKeyword(values.keyword)
        }
        const month: number = parseInt(moment().format('MM'))
        const year: number = parseInt(moment().format('YYYY')) + 543
        const dateCreated = `${moment().format('DD')} ${
          thaimonth[month - 1]
        } ${year} ${moment().format('HH:mm')} น.`
        setDatetimeSearch(dateCreated)
        setIsLoading(false)
        setResult(res.data)
      })
      .catch(err => {
        Swal.fire({
          title: 'Error!',
          text: 'เกิดข้อผิดพลาด',
          icon: 'error',
          confirmButtonText: 'ปิด',
        })
      })
  }

  useEffect(() => {
    window.scrollTo(0, 0)
    if (serial) {
      searchKeyword(initialValues)
    }
  }, [])
  return (
    <div className="page-wrapper">
      {isLoading && (
        <div
          id="overlay"
          style={{
            width: '100vw',
            height: '100vh',
            position: 'fixed',
            backgroundColor: '#000000CC',
            top: 0,
            left: 0,
            zIndex: 9999,
            fontSize: 40,
            color: '#FFF',
            textAlign: 'center',
            paddingTop: '20%',
          }}>
          ระบบกำลังค้นหาข้อมูล ...
        </div>
      )}
      <section className="update-breadcrumb">
        <div className="auto-container">
          <div className="sec-title">
            <div className="clearfix">
              <ul className="cbreadcrumb">
                <li>
                  <Link to="/">หน้าหลัก</Link>
                </li>
                <li>ตรวจสอบเลขผลิตภัณฑ์สุขภาพ</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section className="search-keyword">
        <div className="auto-container">
          <div className="newsletter-form">
            <Formik
              initialValues={initialValues}
              validationSchema={FormSchema}
              onSubmit={async (values, actions) => {
                searchKeyword(values)
                actions.setSubmitting(false)
              }}>
              {({ errors, touched, resetForm }) => (
                <Form method="post" action="" autoComplete="off">
                  <div className="row">
                    <div className="col-12 col-lg-8 col-md-8 col-sm-8">
                      <div className="form-group">
                        <Field type="text" name="keyword" autoComplete="off" />
                        <div style={{ padding: '5px 0 0 19px' }}>{datetimeSearch}</div>
                      </div>
                    </div>
                    <div className="col-12 col-lg-4 col-md-4 col-sm-4">
                      <div className="d-flex">
                        <button
                          type="submit"
                          className="theme-btn btn-style-three h-45 text-center w-50">
                          <span className="txt">
                            <span className="icon fa fa-search mr-2"></span> ค้นหา
                          </span>
                        </button>
                        &nbsp;&nbsp;
                        <a
                          href="#"
                          onClick={() => resetForm()}
                          className="theme-btn btn-style-twelve h-45 text-center w-50">
                          <span className="txt">ล้างค่า</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
            <div className="box_search">
              <div className="share_under_search_bar">
                {/* <ul className="social-box d-flex">
                                    <li><a href="#"><img src="/assets/images/icons/ifacebook-c.png" className="w-50p" alt="fb" /></a></li>
                                    <li><a href="#"><img src="/assets/images/icons/iline-c.png" className="w-50p" alt="iline" /></a></li>
                                    <li><a href="#"><img src="/assets/images/icons/itwitter-c.png" className="w-50p" alt="fitwitter" /></a></li>
                                </ul> */}
              </div>
            </div>
          </div>
        </div>
      </section>
      {result.length > 0 && (
        <section className="search-result">
          <div className="auto-container">
            {/* {result.map((item, index) => <ResultBox key={`resultBox${index}`} result={item}/>)} */}

            {result.map((item, index) => (
              <ResultBox key={`resultBox${index}`} result={item} />
            ))}
          </div>
        </section>
      )}
      {result.length === 0 && !resultNotFound && (
        <section className="mission-section style-two">
          <div className="auto-container">
            <div className="row clearfix">
              <div className="image-column col-lg-6 col-md-12 col-sm-12">
                <div className="inner-column">
                  <div
                    className="image wow fadeInLeft"
                    data-wow-delay="0ms"
                    data-wow-duration="1500ms">
                    <img src="/assets/images/resource/mission.png" alt="" />
                  </div>
                </div>
              </div>

              <div className="content-column col-lg-6 col-md-12 col-sm-12">
                <div className="inner-column">
                  <div className="ml-3 mr-3">
                    <p>วิธีการเช็กเลขที่ผลิตภัณฑ์สุขภาพ</p>
                    <p>
                      *กรุณากรอกข้อมูลให้ตรงตามข้อมูลบนฉลาก ทั้งตัวอักษร ตัวพิมพ์ใหญ่ สัญลักษณ์
                      และตัวเลขโดยไม่ต้องเว้นวรรค
                    </p>
                    <p>
                      ตัวอย่างการเช็กเลข ผลิตภัณฑ์เครื่องสำอาง
                      <br />
                      10-1-53-99999 หรือ 10-1-5399999999
                    </p>
                    <p>
                      ตัวอย่างการเช็กเลข ผลิตภัณฑ์อาหาร
                      <br />
                      10-3-99999-1-9999
                    </p>
                    <p>
                      ตัวอย่างการเช็กเลข ผลิตภัณฑ์วัตถุอันตรายที่ใช้ในบ้านเรือน
                      <br />
                      วอส.99/25XX หรือ 99/25XX
                    </p>
                    <p>
                      ตัวอย่างการเช็กเลข ผลิตภัณฑ์ยา
                      <br />
                      1A 234/56XX
                    </p>
                    <p>
                      ตัวอย่างการเช็กเลข ผลิตภัณฑ์เครื่องมือแพทย์
                      <br />
                      ผ. 234/56XX หรือ น. 234/56XX
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {resultNotFound && (
        <section className="mission-section style-two">
          <div className="auto-container">
            <div className="row clearfix">
              <div className="content-column col-12">
                <div className="inner-column">
                  <div className="ml-3 mr-3 not-found">
                    <h5>ไม่พบเลขผลิตภัณฑ์ที่ท่านค้นหา : {notFoundKeyword}</h5>
                    <p className="subs pb-3">กรณีที่ตรวจสอบเลขผลิตภัณฑ์ อย. ไม่พบอาจเกิดจาก</p>
                    <ol className="pb-3">
                      <li>พิมพ์ตัวเล็ก หรือสัญลักษณ์ ของผลิตภัณฑ์สุขภาพไม่ถูกต้อง/ไม่ครบถ้วน</li>
                      {/* <li>
                        เป็นผลิตภัณฑ์สุขภาพที่ขออนุญาตรายใหม่ จึงอาจทำให้ไม่มีข้อมูลในระบบ
                        กรุณาตรวจสอบใหม่ใน 5-7 วัน
                      </li>
                      <li>
                        กรณีเป็นผลิตภัณฑ์อาหาร/เครื่องสำอาง
                        อาจเป็นผลิตภัณฑ์สุขภาพที่มีการขออนุญาตที่สำนักงานสาธารณสุขจังหวัด
                        จีงอาจไม่มีข้อมูลในระบบ
                      </li> */}
                      <li>ไม่มีเลขผลิตภัณฑ์ที่ท่านค้นหา</li>
                    </ol>
                    <p>กรณีพบปัญหาเกี่ยวกับการตรวจเลข สามารถแจ้งเจ้าหน้าที่ตรวจสอบได้ที่นี่</p>
                    <Link
                      to="/appeal"
                      state={{ keyword: notFoundKeyword }}
                      className="theme-btn btn-style-three  text-center">
                      <span className="txt">แจ้งปัญหาตรวจเลขผลิตภัณฑ์</span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </div>
  )
}
export default CheckProductSerial
